const FanZoneController1 = () => import('./Controller1')
const FanZoneController = () => import('./Controller')
const Sort = () => import('./Sort')

export default function installComponents(Vue) {
  Vue.component('FanZoneController', FanZoneController)
  Vue.component('FanZoneController1', FanZoneController1)
  Vue.component('Sort', Sort)
}
